import { CommonModal } from "@/components/ui/CommonModal";
import { useModal } from "@/hooks/modals/useModal";
import { Form } from "antd";
import { useInitFormValues } from "../hooks/useInitFormValues";
import type { PurchaseRequestForm } from "../type";
import {
  FlowFormPanelLayout,
  FormSectionLayout,
} from "@/components/ui/FlowFormPanel/FlowFormPanel";
import ProcessTimeline from "@/components/SelfProcessTimeline";
import { usePurchaseRequestForm } from "../hooks/usePurchaseRequestForm";
import { usePurchaseRequestDetail } from "../hooks/usePurchaseRequest";
import { useFlowNodeQuery } from "@/hooks/services/useFlow";
import { useFormFooter } from "../hooks/useFormFooter";
import { FlowModalTitle } from "@/components/ui/FlowModalTitle";

export const PurchaseRequestModal = () => {
  const [form] = Form.useForm<PurchaseRequestForm>();
  const { open, closeModal, props } = useModal("PURCHASE_REQUEST");
  const { recordId } = props;

  const detail = usePurchaseRequestDetail(recordId);

  const isFlowFinished = ["3", "4"].includes(detail?.reviewStatus ?? "");

  const MatchedForm = usePurchaseRequestForm();

  const cleanup = () => {
    closeModal();
    form.resetFields();
  };

  const timeLineItems = useFlowNodeQuery(detail?.insId);

  useInitFormValues(form, detail);

  const renderFooter = useFormFooter(form, cleanup);

  return (
    <CommonModal
      width={1300}
      title={
        <FlowModalTitle
          title="采购申请表"
          processCode={detail?.applicationNo}
        />
      }
      open={open}
      onCancel={cleanup}
      centered
      footer={null}
    >
      <FlowFormPanelLayout
        leftPanel={
          <FormSectionLayout
            body={MatchedForm && <MatchedForm form={form} />}
            footer={renderFooter()}
          />
        }
        rightPanel={
          <ProcessTimeline
            items={timeLineItems}
            showFinishedFlag={isFlowFinished}
          />
        }
        showRightPanel={timeLineItems.length > 0}
      />
    </CommonModal>
  );
};
